let InstallersPage = (function () {

    function filterInstallers(selectedValue, defaultValue) {
        const normalizedSelected = (selectedValue || "").trim().toLowerCase();
        const normalizedDefault  = (defaultValue || "").trim().toLowerCase();
        const showAll = !normalizedSelected || normalizedSelected === normalizedDefault;

        const installers = document.querySelectorAll(".installer");
        const noFoundEl = document.querySelector(".no-installers-found");

        let visibleCount = 0;

        installers.forEach(installer => {
            const areasEl = installer.querySelector(".installer-areas");

            // jeśli nie ma informacji o obszarach – pokazuj tylko przy showAll
            if (!areasEl) {
                installer.style.display = showAll ? "flex" : "none";
                return;
            }

            const text = areasEl.textContent || "";
            const areas = text
                .split(", ")
                .map(a => a.trim().toLowerCase())
                .filter(a => a.length > 0);

            const match = showAll || areas.includes(normalizedSelected);

            installer.style.display = match ? "flex" : "none";

            if (match) visibleCount++;

        });

        if (noFoundEl) {
            if (visibleCount === 0) {
                noFoundEl.style.display = "";
            } else {
                noFoundEl.style.display = "none";
            }
        }
    }

    function initAreaDopdown()
    {
        document.querySelectorAll(".area-dropdown").forEach(dropdown => {
            const selectedText = dropdown.querySelector(".area-selected-text");
            const button       = dropdown.querySelector(".dropdown-button");
            const menu         = dropdown.querySelector(".dropdown-content");
            const defaultValue = (dropdown.dataset.defaultOption || "").trim();

            // initial filter – na wypadek gdyby domyślna nie oznaczała "wszystkie"
            const initialValue = (selectedText.textContent || defaultValue).trim();
            filterInstallers(initialValue, defaultValue);

            // wybór opcji
            dropdown.querySelectorAll(".dropdown-option").forEach(option => {
                option.addEventListener("click", () => {
                    const value = option.dataset.value;

                    // ustaw tekst
                    selectedText.textContent = value;

                    // zamknij dropdown
                    dropdown.classList.remove("open");

                    // filtruj instalatorów
                    filterInstallers(value, defaultValue);
                });
            });

            // klik poza dropdownem → zamyka
            document.addEventListener("click", (e) => {
                if (!dropdown.contains(e.target)) {
                    dropdown.classList.remove("open");
                }
            });
        });


    }

    function init()
    {

        document.addEventListener('DOMContentLoaded', function() {
            Custom.initDropdowns();
            initAreaDopdown();
        });


    }

    init();


    return {

    }
})();